export default __webpack_public_path__ + "static/media/01.200eeabe.jpg";